(function() {
	let root =
		(typeof self == 'object' && self.self === self && self) ||
		(typeof global == 'object' && global.global === global && global) ||
		this ||
		{};
	let configs = {
		'[a-z-]*.omnitracsone.com': {
			env: 'prod',
			sso: {
				issuer: 'https://fedsso.omnitracs.com',
				logoutUrl: 'https://login.omnitracsone.com/assets/deeplink/?to=/logout',
				clientId: 'platform_system',
				flow: 'OT1_PROD'
			},
			clients: {
				apiOneExternal: { url: 'https://one-api.omnitracsone.com/' },
				tokenUrl: { url: '' }
			},
			apis: {
				platform: { url: 'https://one-api.omnitracsone.com' }
			}
		},
		'.*.beta.omnitracsone.com': {
			env: 'beta',
			sso: {
				issuer: 'https://fedsso.perf.omnitracs.com',
				logoutUrl: 'https://login.beta.omnitracsone.com/assets/deeplink/?to=/logout',
				clientId: 'platform_system',
				flow: 'OT1_BETA'
			},
			clients: {
				apiOneExternal: { url: 'https://one-api.beta.omnitracsone.com/' },
				tokenUrl: { url: '' }
			},
			apis: {
				platform: { url: 'https://one-api.beta.omnitracs.com' }
			}
		},
		'.*.stage.omnitracsone.com': {
			env: 'stage',
			sso: {
				issuer: 'https://fedsso.perf.omnitracs.com',
				logoutUrl: 'https://login.stage.omnitracsone.com/assets/deeplink/?to=/logout',
				flow: 'OT1_STAGE',
				clientId: 'platform_system'
			},
			clients: {
				apiOneExternal: { url: 'https://one-api.stage.omnitracsone.com/' },
				tokenUrl: { url: '' }
			},
			apis: {
				platform: { url: 'https://one-api.stage.omnitracs.com' }
			}
		},
		'.*.perf.omnitracsone.com': {
			env: 'perf',
			sso: {
				issuer: 'https://fedsso.perf.omnitracs.com',
				logoutUrl: 'https://login.perf.omnitracsone.com/assets/deeplink/?to=/logout',
				flow: 'OT1_PERF',
				clientId: 'platform_system'
			},
			clients: {
				apiOneExternal: { url: 'https://one-api.perf.omnitracsone.com/' },
				tokenUrl: { url: '' }
			},
			apis: {
				platform: { url: 'https://one-api.perf.omnitracsone.com' }
			}
		},
		'.*.test.omnitracsone.com': {
			env: 'test',
			sso: {
				issuer: 'https://fedsso.perf.omnitracs.com',
				logoutUrl: 'https://login.test.omnitracsone.com/assets/deeplink/?to=/logout',
				flow: 'OT1_TEST',
				clientId: 'platform_system'
			},
			clients: {
				apiOneExternal: { url: 'https://one-api.test.omnitracsone.com/' },
				tokenUrl: { url: '' }
			},
			apis: {
				platform: { url: 'https://one-api.test.omnitracsone.com' }
			}
		},
		'.*.dev.omnitracsone.com': {
			env: 'dev',
			sso: {
				issuer: 'https://fedsso.perf.omnitracs.com',
				logoutUrl: 'https://login.dev.omnitracsone.com/assets/deeplink/?to=/logout',
				flow: 'OT1_DEV',
				clientId: 'platform_system'
			},
			clients: {
				apiOneExternal: { url: 'https://one-api.dev.omnitracsone.com/' },
				tokenUrl: { url: '' }
			},
			apis: {
				platform: { url: 'https://one-api.dev.omnitracsone.com' }
			}
		},
		'.*.tkg-flt-dev.usdc01.solera.farm': {
			env: 'dev',
			sso: {
				issuer: 'https://fedsso.perf.omnitracs.com',
				logoutUrl: 'https://login.dev.omnitracsone.com/assets/deeplink/?to=/logout',
				flow: 'OT1_DEV',
				clientId: 'platform_system'
			},
			clients: {
				apiOneExternal: { url: 'https://one-api.dev.omnitracsone.com/' },
				tokenUrl: { url: '' }
			},
			apis: {
				platform: { url: 'https://one-api.dev.omnitracsone.com' }
			}
		},
		'.*.tkg-flt-qae.usdc01.solera.farm': {
			env: 'test',
			sso: {
				issuer: 'https://fedsso.perf.omnitracs.com',
				logoutUrl: 'https://login.test.omnitracsone.com/assets/deeplink/?to=/logout',
				flow: 'OT1_TEST',
				clientId: 'platform_system'
			},
			clients: {
				apiOneExternal: { url: 'https://one-api.test.omnitracsone.com/' },
				tokenUrl: { url: '' }
			},
			apis: {
				platform: { url: 'https://one-api.test.omnitracsone.com' }
			}
		},
		'.*.tkg-flt-cae.usdc01.solera.farm': {
			env: 'stage',
			sso: {
				issuer: 'https://fedsso.perf.omnitracs.com',
				logoutUrl: 'https://login.stage.omnitracsone.com/assets/deeplink/?to=/logout',
				flow: 'OT1_STAGE',
				clientId: 'platform_system'
			},
			clients: {
				apiOneExternal: { url: 'https://one-api.stage.omnitracsone.com/' },
				tokenUrl: { url: '' }
			},
			apis: {
				platform: { url: 'https://one-api.stage.omnitracs.com' }
			}
		},
		'.*.tkg-flt-prod.usdc01.solera.farm': {
			env: 'prod',
			sso: {
				issuer: 'https://fedsso.omnitracs.com',
				logoutUrl: 'https://login.omnitracsone.com/assets/deeplink/?to=/logout',
				clientId: 'platform_system',
				flow: 'OT1_PROD'
			},
			clients: {
				apiOneExternal: { url: 'https://one-api.omnitracsone.com/' },
				tokenUrl: { url: '' }
			},
			apis: {
				platform: { url: 'https://one-api.omnitracsone.com' }
			}
		},
		'.*localhost.*': {
			env: 'local',
			sso: {
				issuer: 'https://fedsso.perf.omnitracs.com',
				logoutUrl: 'https://login.dev.omnitracsone.com/assets/deeplink/?to=/logout',
				flow: 'OT1_DEV',
				clientId: 'platform_system'
			},
			clients: {
				apiOneExternal: { url: 'https://one-api.dev.omnitracsone.com/' },
				tokenUrl: { url: '' }
			},
			apis: {
				platform: { url: 'https://one-api.dev.omnitracsone.com' }
			}
		}
	};
	if (typeof exports !== 'undefined') {
		if (typeof module !== 'undefined' && module.exports) {
			exports = module.exports = configs;
		}
		exports.configs = configs;
	} else {
		root.configs = configs;
	}
})();
